
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";

export interface ProfileSharesProps {
  shares: any[];
  isOwnProfile: boolean;
}

export function ProfileShares({ shares, isOwnProfile }: ProfileSharesProps) {
  if (shares.length === 0) {
    return (
      <Card>
        <CardContent className="p-6 text-center">
          <p className="text-muted-foreground">
            {isOwnProfile 
              ? "Você ainda não compartilhou nenhum conteúdo" 
              : "Este usuário ainda não compartilhou nenhum conteúdo"}
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {shares.map((share) => {
        const post = share.posts;
        return (
          <Card key={share.id}>
            <CardContent className="p-4">
              <div className="aspect-square bg-muted rounded-md overflow-hidden mb-2">
                {post?.image_url && (
                  <img
                    src={post.image_url}
                    alt={post.title || 'Shared post'}
                    className="object-cover w-full h-full"
                  />
                )}
              </div>
              
              <h3 className="font-medium line-clamp-1">{post?.title || 'Sem título'}</h3>
              
              {post?.description && (
                <p className="text-sm text-muted-foreground line-clamp-2 mt-1">
                  {post.description}
                </p>
              )}
              
              <p className="text-xs text-muted-foreground mt-2">
                Compartilhado em {new Date(share.created_at).toLocaleDateString()}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
